// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1367":"eacec5de","2547":"057d35b8","3614":"20402c2a","4044":"94b6c0fb"}[chunkId] + ".chunk.css";
};